module.exports = require('./helpers/bundle-url').getBundleURL('b42qH') + "logo.c51670a8.svg";